import React from "react";
import { Icon } from "@iconify/react";
export const SOCIALS = [
    {
        identifier: "facebook",
        image: React.createElement(Icon, { icon: "lucide:facebook", width: "24", height: "24" }),
        url: "",
    },
    {
        identifier: "twitter",
        image: React.createElement(Icon, { icon: "lucide:twitter", width: "24", height: "24" }),
        url: "",
    },
    {
        identifier: "instagram",
        image: React.createElement(Icon, { icon: "lucide:instagram", width: "24", height: "24" }),
        url: "",
    },
    {
        identifier: "pinterest",
        image: React.createElement(Icon, { icon: "iconoir:pinterest", width: "24", height: "24" }),
        url: "",
    },
    {
        identifier: "youtube",
        image: React.createElement(Icon, { icon: "iconoir:youtube", width: "24", height: "24" }),
        url: "",
    },
];
